import * as theme from "../theme";

const InvalidLink = () => {
  return (
    <div
      style={{
        ...theme.fwfh,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginLeft: "12rem",
          marginRight: "12rem",
        }}
      >
        <div
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 35,
            color: theme.COLORS.primary_navyblue,
          }}
        >
          Oops! Invalid link!
        </div>
      </div>
    </div>
  );
};

export default InvalidLink;
